import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

console.log(BASE_URL)
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const request = async (config) => {
  if (!config) {
    throw new Error("Config is required");
  }
  if (!config.headers) {
    config.headers = { "Content-Type": "application/json" };
  }

  const token = localStorage.getItem("token");

  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }

  try {
    const response = await axiosInstance.request(config);

    return {
      remote: "success",
      data: response.data,
    };
  } catch (error) {
    const status = error.status;
    if (status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      remote: "error",
      error: error.response.data,
    };
  }
};
